module.exports = __webpack_public_path__ + "img/pic_2@2x.dd04b257.png";